<template>
  <div class="ai-mode-switch">
    <button
      type="button"
      class="ai-mode-switch__btn"
      :class="{ 'ai-mode-switch__btn--active': value === 'ki' }"
      @click="emitValue('ki')"
    >
      {{ translations[15926] }}
    </button>
    <button
      type="button"
      class="ai-mode-switch__btn"
      :class="{ 'ai-mode-switch__btn--active': value === 'berufsgruppe' }"
      @click="emitValue('berufsgruppe')"
    >
      {{ translations[3848] }}
    </button>
    <button
      v-if="showVolltext"
      type="button"
      class="ai-mode-switch__btn"
      :class="{ 'ai-mode-switch__btn--active': value === 'volltext' }"
      @click="emitValue('volltext')"
    >
      {{ translations[10434] }}
    </button>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

export type AiCustomCheckboxValue = 'ki' | 'berufsgruppe' | 'volltext';

@Component({})
export default class AiCustomCheckbox extends Vue {
  @Prop({ type: String, default: 'ki' }) value!: AiCustomCheckboxValue;

  @Prop({ type: Boolean, default: true }) showVolltext!: boolean;

  emitValue(mode: AiCustomCheckboxValue) {
    this.$emit('input', mode);
  }

  get translations() {
    return AppModule.translation;
  }
}
</script>

<style lang="scss" scoped>
.ai-mode-switch {
  display: inline-flex;
  padding: 0.25rem;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(12px);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  &__btn {
    padding: 0.375rem 1.25rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.25rem;
    white-space: nowrap;
    color: #004f9f;
    background: transparent;
    border: 0;
    border-radius: 9999px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.6);
    }

    &--active {
      color: #fff;
      background: #004f9f;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);

      &:hover {
        background: #004f9f;
      }
    }
  }
}
</style>
